import { registerView, ViewComponent, View, preventDefault } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button/index";
import { observer, Observer } from "mobx-react-lite";
import { useCallback } from "react";
import * as React from "react";
import { Form, Row, Col } from "react-bootstrap";
import PaymentValidationViewModel from "viewModels/paymentValidation/paymentValidationViewModel";
import LoadingPane from "../../controls/loadingPane";
import ErrorCard from "../common/error/errorCard";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";

const PaymentValidationView: ViewComponent<PaymentValidationViewModel> = observer(({ vm }) => {
  const tg = (code: string) => vm.localizationService.translateGeneral(`validation.${code}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.childElement = node;
    }
  }, []);

  let child;
  if (vm.activeChild) {
    child = <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
  } else {
    child = (
      <Form onSubmit={preventDefault(vm.validate)}>
        <View vm={vm.vehicleInfoViewModel} />
        <Row>
          <Col md={6}>
            <Button type="submit" disabled={vm.busyWatcher.isBusy} block={true}>
              {tg("validate")}
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }

  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy} loader={<LoadingPane />}>
      {vm.errorMessage && <ErrorCard message={tg(vm.errorMessage)} />}
      <h3 className="text-center text-lg-left">{tg("title_full")}</h3>
      <p className={"mb-4 pr-3 pr-md-7"} dangerouslySetInnerHTML={{ __html: tg("description") }} />
      <div ref={formRef}>{child}</div>
    </LoaderOverlay>
  );
});

registerView(PaymentValidationView, PaymentValidationViewModel);
